<template>
    <div
        class="px-5 container max-w-6xl mx-auto"
        uk-lightbox
    >
        <div class="flex flex-wrap -m-3">
            <div
                v-for="(image, index) in doc.images"
                :key="index"
                class="p-3 w-1/2 md:w-1/3"
            >
                <div class="uk-transition-toggle overflow-hidden">
                    <a :href="baseURL + '/assets/' + image">
                        <asset
                            :url="image"
                            :w="400"
                            :h="300"
                            fit="crop_focal"
                            class="uk-transition-scale-up uk-transition-opaque"
                        />
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ["doc"]
};
</script>



// WEBPACK FOOTER //
// src/components/Gallery.vue